import { Fragment } from "react";
import { formatDateTime, formatNumberWithCommas } from "../../lib/utils";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartLegend
  } from "@progress/kendo-react-charts";

  import "hammerjs";

  import { useTranslation } from "react-i18next";

export const AlertNotificationNotGrouped = props =>
{
    const {currentTheme, resolvedExpression, value, operatorTitle, thresholdMin, thresholdMax, variation, isPercent, history, isVariant, ...other} = props;

    const dates = history.map(item => formatDateTime(item.Key, false));
    const values = history.map(item => item.Value);

    const { t } = useTranslation();

    let thresholdText = formatNumberWithCommas(thresholdMin, 4) + (isPercent ? "%" : "");
    if (operatorTitle.toLowerCase().indexOf("in") >= 0)
        thresholdText += " - " + formatNumberWithCommas(thresholdMax, 4) + (isPercent ? "%" : "");

    return(
        <Fragment>
            <div className="alert-notification-not-grouped">
                <div className="alert-notification-not-grouped-left">
                    {/* <div style={{fontSize: 14, fontWeight: 700}}>Data</div> */}
                    <div style={{marginLeft: 8, display: "flex", flexDirection: "column", fontSize: 13}}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.keymetric")}</div>
                            <div style={{flex:1}}>: &nbsp;{resolvedExpression}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", marginTop:20}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.type")}</div>
                            <div style={{flex:1}}>: &nbsp;{isVariant ? t("notifications.variant_alert") : t("notifications.value_alert")}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", marginTop:20}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.value")}</div>
                            <div style={{flex:1}}>:  &nbsp;{formatNumberWithCommas(value, 4)}{(isPercent || isVariant) ? " %" : ""}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", marginTop:20}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.operator")}</div>
                            <div style={{flex:1}}>:  &nbsp;{operatorTitle}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", marginTop:20}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.thresh")}</div>
                            <div style={{flex:1}}>:  &nbsp;{thresholdText}</div>
                        </div>

                        <div style={{display: "flex", alignItems: "center", marginTop:20}}>
                            <div style={{width: 110, fontWeight: 700}}>{t("notifications.variation")}</div>
                            <div style={{flex:1}}>: &nbsp;{variation == null ? t("notifications.not_applicable") :  `${formatNumberWithCommas(variation,4)} %`}</div>
                        </div>
                    </div>
                </div>
                <div className="alert-notification-not-grouped-right">
                    <Chart style={{height: "100%", weight: "100%"}}>
                        <ChartCategoryAxis>
                            <ChartCategoryAxisItem categories={dates} labels={{rotation: 30}}/>
                        </ChartCategoryAxis>
                        <ChartSeries>
                            <ChartSeriesItem type="line" data={values} tooltip={{visible: true }}/>
                        </ChartSeries>
                    </Chart>
                </div>
            </div>
            <style>
                {
                    `
                    .notifications-page .alert-notification-not-grouped 
                    {
                        display: flex;
                        flex:1;
                        align-items: stretch;
                        justify-content: space-between;
                        margin-top: 6px;
                        height: 100%;
                    }

                    .notifications-page .alert-notification-not-grouped .alert-notification-not-grouped-left
                    {
                        border: 1px solid ${currentTheme.componentBorderColor};
                        padding: 24px 16px;
                        width: calc(50% - 30px);
                        min-height: 300px;
                    }

                    .notifications-page .alert-notification-not-grouped .alert-notification-not-grouped-right
                    {
                        border: 1px solid ${currentTheme.componentBorderColor};
                        padding: 0;/*4px 16px;*/
                        width: 50%;
                        min-height: 300px;
                    }
                    `
                }
            </style>
        </Fragment>
    );
};
